import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '@/lib/utils';

export const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    dashed?: boolean;
    strong?: boolean;
  }
>(({ className, orientation = 'horizontal', decorative = true, dashed, strong, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      'shrink-0',
      strong ? 'bg-fd-border-strong' : 'bg-fd-border',
      orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
      dashed && [
        'bg-transparent',
        orientation === 'horizontal'
          ? 'h-0 border-t border-dashed'
          : 'w-0 border-l border-dashed',
        strong ? 'border-fd-border-strong' : 'border-fd-border',
      ],
      className,
    )}
    {...props}
  />
));
Separator.displayName = 'Separator';
